import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BaseServiceFacade,
  GenericApiCall,
} from '../../../../common/store/types';
import { AppState } from '../../types';
import { WorkLocationModel } from './types';
import { workLocationActions } from './work-location.actions';
import { workLocationSelectors } from './work-location.selector';

@Injectable()
export class WorkLocationService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getById: GenericApiCall<WorkLocationModel, number> = this.genericApiCall(
    workLocationActions.getById,
    workLocationSelectors.getById,
    true,
  );
  createInstance: GenericApiCall<WorkLocationModel, void> =
    this.genericApiCall(
      workLocationActions.createInstance,
      workLocationSelectors.createInstance,
      true,
    );
  add: GenericApiCall<WorkLocationModel, WorkLocationModel> =
    this.genericApiCall(
      workLocationActions.add,
      workLocationSelectors.add,
      true,
    );
  update: GenericApiCall<WorkLocationModel, WorkLocationModel> =
    this.genericApiCall(
      workLocationActions.update,
      workLocationSelectors.update,
      true,
    );
  delete: GenericApiCall<boolean, number> = this.genericApiCall(
    workLocationActions.delete,
    workLocationSelectors.delete,
    true,
  );
}
